import { render, staticRenderFns } from "./BusinessProfileRegister.html?vue&type=template&id=8e8b0978&scoped=true&"
import script from "./BusinessProfileRegister.vue?vue&type=script&lang=js&"
export * from "./BusinessProfileRegister.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProfileRegister.scss?vue&type=style&index=0&id=8e8b0978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8b0978",
  null
  
)

export default component.exports